import "./WeeklySchedule.css"; // Archivo de estilos
import { useState, useEffect } from 'react';
import weeklyScheduleProvider from "../../provider/WeeklySchedule.provider";
import { WeeklyScheduleDto, DayOfWeek, TimeSlotDto, WeeklyScheduleClient, CreateUpdateWeeklyScheduleDto} from "../../services/ohl.virtualCenter.api";
import { useNotify } from "ra-core";
import { Box, Chip  } from '@material-ui/core';

const apiWeeklyScheduleClient = new WeeklyScheduleClient(process.env.REACT_APP_PUBLIC_API);

const days = [
    { name: "Lunes", day: DayOfWeek.Monday, enabled: true },
    { name: "Martes", day: DayOfWeek.Tuesday, enabled: true },
    { name: "Miércoles", day: DayOfWeek.Wednesday, enabled: true },
    { name: "Jueves", day: DayOfWeek.Thursday, enabled: true },
    { name: "Viernes", day: DayOfWeek.Friday, enabled: true },
    { name: "Sábado", day: DayOfWeek.Saturday, enabled: true },
    { name: "Domingo", day: DayOfWeek.Sunday, enabled: true }
];

export const WeeklySchedule = (props) => {
    const { isProfessional, scheduleEdit, isSave, errors, setErrors, setIsSave  } = props;
    const [weeklySchedules, setWeeklySchedules] = useState([]);
    const notify = useNotify()

    // Estado para almacenar los horarios de cada día y columna
    const [schedule, setSchedule] = useState(
        days.map(day => ({
            name: day.name,
            enabled: scheduleEdit,
            day: day.day,
            times: ["", "", "", ""] // Inicio, Descanso, Fin Descanso, Fin
        }))
    );

    useEffect(() => {

        if(props?.id) fetchWeeklySchedules(props?.id)
        // eslint-disable-next-line
    }, []);
    
    useEffect(() => {

        if(isSave) handleSave()
        // eslint-disable-next-line
    }, [isSave]);
            
    // Efecto para cargar los horarios cuando weeklySchedules esté disponible
    useEffect(() => {
        setSchedule(
            days.map((day, index) => {
                // Buscar el horario que corresponde a este día
                const backendDayOrder = index === 6 ? 0 : index + 1;

                const daySchedule = weeklySchedules.find(ws => ws.dayOrder === backendDayOrder);
                
                // Inicializar times con valores vacíos
                const times = ["", "", "", ""];
                
                if (daySchedule?.timeBlocks) {
                    // Ordenar los timeBlocks por su order (por si acaso vienen desordenados)
                    const sortedTimeBlocks = [...daySchedule.timeBlocks].sort((a, b) => a.order - b.order);
                    
                    // Asignar cada timeBlock a su posición correspondiente según el order
                    sortedTimeBlocks.forEach(block => {
                        const position = (block.order - 1) * 2; // order 1 -> posición 0, order 2 -> posición 2
                        if (position >= 0 && position + 1 < times.length) {
                            times[position] = block.startTimeTS || "";
                            times[position + 1] = block.endTimeTS || "";
                        }
                    });
                }
                
                return {
                    id: daySchedule?.id,
                    clientId: !isProfessional? props?.id : null,
                    professionalId: isProfessional? props?.id : null,
                    isProfesionalWeeklySchedule: isProfessional,
                    name: day.name,
                    enabled: scheduleEdit,
                    day: day.day,
                    times: times
                };
            })
        );
        
        // eslint-disable-next-line
    }, [weeklySchedules, scheduleEdit]);
    
        
    // Función auxiliar para convertir tiempo HH:MM a minutos
    const timeToMinutes = (time) => {
        if (!time) return 0;
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    };


    const handleTimeChange = (dayIndex, colIndex, newTime) => {
        const updatedSchedule = [...schedule];
        updatedSchedule[dayIndex].times[colIndex] = newTime;
        
        // Limpiar errores previos para este día
        const newErrors = {...errors};
        delete newErrors[dayIndex];
        setErrors(newErrors);
        
        const currentDay = updatedSchedule[dayIndex];
        const [morningStart, morningEnd, afternoonStart, afternoonEnd] = currentDay.times;
    
        if (isProfessional) {
            // VALIDACIONES PARA PROFESIONALES
            
            // 1. Si hay algún campo completado, todos deben estar completos
            const hasAnyTime = currentDay.times.some(time => time);
            const allFilled = currentDay.times.every(time => time);
            
            if (hasAnyTime && !allFilled) {
                setErrors({...newErrors, [dayIndex]: "❗ Complete todos los campos"});
            }
            
            // 2. Validaciones de orden (solo si ambos campos existen)
            if (morningStart && morningEnd && timeToMinutes(morningEnd) <= timeToMinutes(morningStart)) {
                setErrors({...newErrors, [dayIndex]: "⏰ Hora de descanso incorrecta"});
            }
            
            if (afternoonStart && afternoonEnd && timeToMinutes(afternoonEnd) <= timeToMinutes(afternoonStart)) {
                setErrors({...newErrors, [dayIndex]: "🔚 Fin descanso incorrecto"});
            }
            
            if (morningEnd && afternoonStart && timeToMinutes(afternoonStart) <= timeToMinutes(morningEnd)) {
                setErrors({...newErrors, [dayIndex]: "🚪 Fin jornada incorrecto"});
            }
    
        } else {
            // VALIDACIONES PARA NO PROFESIONALES
            
            // 1. Validación por bloques (mañana/tarde)
            const morningFilled = morningStart || morningEnd;
            const afternoonFilled = afternoonStart || afternoonEnd;
            
            if (morningFilled && (!morningStart || !morningEnd)) {
                setErrors({...newErrors, [dayIndex]: "❗ Complete horario mañana"});
            }
            
            if (afternoonFilled && (!afternoonStart || !afternoonEnd)) {
                setErrors({...newErrors, [dayIndex]: "❗ Complete horario tarde"});
            }
            
            // 2. Validaciones de orden temporal
            if (morningStart && morningEnd && timeToMinutes(morningEnd) <= timeToMinutes(morningStart)) {
                setErrors({...newErrors, [dayIndex]: "⏰  Fin mañana debe ser después"});
            }
            
            if (afternoonStart && afternoonEnd && timeToMinutes(afternoonEnd) <= timeToMinutes(afternoonStart)) {
                setErrors({...newErrors, [dayIndex]: "⏰ Fin tarde debe ser después"});
            }
            
            if (morningEnd && afternoonStart && timeToMinutes(afternoonStart) <= timeToMinutes(morningEnd)) {
                setErrors({...newErrors, [dayIndex]: "🚫 Tarde, posterior a mañana"});
            }
        }
        
        setSchedule(updatedSchedule);
    };

    function generateTimeSlots(startHour, endHour, intervalMinutes = 15) {
        const times = [];
        for (let hour = startHour; hour <= endHour; hour++) {
            for (let minute = 0; minute < 60; minute += intervalMinutes) {
                const formattedHour = hour.toString().padStart(2, '0');
                const formattedMinute = minute.toString().padStart(2, '0');
                times.push(`${formattedHour}:${formattedMinute}`);
            }
        }
        return times;
    }

    // Ejemplo: Generar desde 07:00 hasta 21:30
    const timeOptions = generateTimeSlots(7, 21).filter(time => {
        return time >= "07:00";
    });

    const fetchWeeklySchedules = async (filterId) => {
            const res = await weeklyScheduleProvider.getList(null, {
                pagination: { page: 1, perPage: 10 },
                sort: { field: 'Id', order: 'DESC' },
                filter: {
                    clientId: !isProfessional? filterId : null,
                    professionalId: isProfessional? filterId : null,
                }
            });
            setWeeklySchedules(res?.data);
    };
    
    
    const handleSave = async () => {

        const weeklySchedulesDto = schedule.map(ws => {
            if (!ws || !ws.times) return null;
        
            // 1. Busca horario existente (si tiene id)
            const existingSchedule = weeklySchedules.find(f => f.id === ws?.id);
            
            // Si existe, actualiza sus timeBlocks con instancias de TimeSlotDto
            if (existingSchedule) {
                //existingSchedule.timeBlocks = [];  // Reinicia los bloques
        
                // Procesa pares de tiempos (start, end) y filtra vacíos
                for (let i = 0; i < ws.times.length - 1; i += 2) {
                    const startTime = ws.times[i];
                    const endTime = ws.times[i + 1];
                    var position = i === 0 ? 1 : 2;
                    const currentPosition = position; // Copia el valor actual
                    
                    if ((startTime && endTime) || (startTime === "" && endTime === "" && existingSchedule?.dayOrder === currentPosition)) {

                        if(existingSchedule?.timeBlocks[0] && i === 0 && existingSchedule?.timeBlocks[0]?.order === 1){
                            existingSchedule.timeBlocks[i].startTimeTS = startTime;
                            existingSchedule.timeBlocks[i].endTimeTS = endTime;
                        } else if((existingSchedule?.timeBlocks[1] && i === 2) || (existingSchedule?.timeBlocks[0]?.order === 2)){

                            if(existingSchedule?.timeBlocks?.length > 1){
                                const blockToUpdate = existingSchedule.timeBlocks.find(f => f?.order === currentPosition);
    
                                if (blockToUpdate) {
                                    blockToUpdate.startTimeTS = startTime;
                                    blockToUpdate.endTimeTS = endTime;
                                }
                            }else if(position === existingSchedule?.timeBlocks[0]?.order){
                                existingSchedule.timeBlocks[0].startTimeTS = startTime;
                                existingSchedule.timeBlocks[0].endTimeTS = endTime;
                            } else {
                                existingSchedule.timeBlocks.push(
                                    new TimeSlotDto({  // ¡Asegúrate de usar new TimeSlotDto!
                                        startTimeTS: startTime,
                                        endTimeTS: endTime,
                                        order: position,
                                        weeklyScheduleId: existingSchedule.id
                                    }));
                            }
                            
                            
                        } else if(!existingSchedule?.timeBlocks[0] && i === 0){
                            existingSchedule.timeBlocks.push(
                                new TimeSlotDto({  // ¡Asegúrate de usar new TimeSlotDto!
                                    startTimeTS: startTime,
                                    endTimeTS: endTime,
                                    order: i === 2 ? 2:1,
                                    weeklyScheduleId: existingSchedule.id
                                }));
                        } else if(!existingSchedule?.timeBlocks[1] && i === 2){
                            existingSchedule.timeBlocks.push(
                                new TimeSlotDto({  // ¡Asegúrate de usar new TimeSlotDto!
                                    startTimeTS: startTime,
                                    endTimeTS: endTime,
                                    order: existingSchedule?.timeBlocks[0]?.order === 2 ? 1:2,
                                    weeklyScheduleId: existingSchedule.id
                                }));
                        } 
                        
                    }
                }
                return existingSchedule;
            }
        
            // 2. Si no existe, crea un nuevo DTO (con filtrado de bloques vacíos)
            const hasValidBlocks = ws.times.some((time, index) => {
                if (index % 2 === 0 && index + 1 < ws.times.length) {
                    return ws.times[index] && ws.times[index + 1];
                }
                return false;
            });
        
            if (!hasValidBlocks) return null;
        
            const newDto = new WeeklyScheduleDto({
                id: ws.id || null,
                professionalId: isProfessional ? props?.id : null,
                clientId: !isProfessional ? props?.id : null,
                day: ws.day,
                isWorkingDay: true,
                isProfesionalWeeklySchedule: isProfessional,
                timeBlocks: [],  // Se llenará con TimeSlotDto
            });
        
            // Agrega solo bloques válidos (como TimeSlotDto)
            for (let i = 0; i < ws.times.length - 1; i += 2) {
                const startTime = ws.times[i];
                const endTime = ws.times[i + 1];
                
                if (startTime && endTime) {
                    newDto.timeBlocks.push(
                        new TimeSlotDto({  // ¡Clave! Usar new TimeSlotDto
                            startTimeTS: startTime,
                            endTimeTS: endTime,
                            order: i === 2 ? 2:1,
                        })
                    );
                }
            }
        
            return newDto;
        });

        // Filtra null/undefined y verifica que sean DTOs válidos
        const schedulesToSend = weeklySchedulesDto
            .filter(schedule => schedule !== null && schedule !== undefined)
            .map(schedule => schedule instanceof WeeklyScheduleDto ? schedule : new WeeklyScheduleDto(schedule));

        await apiWeeklyScheduleClient.weeklySchedule(new CreateUpdateWeeklyScheduleDto({ 
            filterId: props.id, 
            isProfesionalWeeklySchedule: isProfessional, 
            weeklySchedules: schedulesToSend
        }));

        notify('Elementos guardados', 'info');
        fetchWeeklySchedules(props?.id);

        setIsSave(false);
    };

    return (
        <div className={`schedule-container ${Object.keys(errors).length > 0 ? 'with-errors' : ''}`}>
            {
                !isProfessional && (<Box display="flex" gap={2} className={`box-horario ${Object.keys(errors).length > 0 ? 'with-errors' : ''}`}>
                    <Chip label="Horario Mañana" color="info" variant="soft" />
                    <Chip label="Horario Tarde" color="warning" variant="soft" />
                </Box>)
            }
            
            <table className="schedule-table">
                <thead>
                    <tr>
                        <th></th>
                        <th className="header">Inicio</th>
                        <th className="header">{isProfessional? 'Descanso/Comida' : 'Fin'}</th>
                        <th className="header">{isProfessional? 'Fin Descanso/Comida' : 'Inicio'}</th>
                        <th className="header">Fin</th>
                    </tr>
                </thead>
                <tbody>
                    {schedule.map((day, dayIndex) => {
                        

                        return (
                            <tr key={day.name} className={!day.enabled ? "disabled-row" : ""}>
                                <td className="day-label">{day.name}</td>
                                {[0, 1, 2, 3].map((colIndex) => (
                                    <td key={colIndex}>
                                        <select
                                                className="time-select"
                                                value={day.times[colIndex]}
                                                disabled={!day.enabled}
                                                onChange={(e) => 
                                                    handleTimeChange(dayIndex, colIndex, e.target.value)
                                                }
                                            >
                                                <option value="">-</option>
                                                {timeOptions.map((time) => (
                                                    <option key={time} value={time}>
                                                        {time}
                                                    </option>
                                                ))}
                                            </select>
                                            
                                </td>
                                ))}
                                {errors[dayIndex] && (
                                    <td colSpan="4" className="error-message">
                                        {errors[dayIndex]}
                                    </td>
                                )}
                                
                            </tr>
                        )
                    }
                        
                        
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default WeeklySchedule;
